import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as savrActionTypes from '../savrActionTypes';

/**
 * Search SAVR pickup location geolocation
 */
const searchSAVRPickupLocationGeolocation = function* searchSAVRPickupLocationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        savrActionTypes.SEARCH_SAVR_PICKUP_LOCATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const responseAction = yield take([
        savrActionTypes.SEARCH_SAVR_PICKUP_LOCATION_GEOLOCATION_REQUEST_SUCCEEDED,
        savrActionTypes.SEARCH_SAVR_PICKUP_LOCATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: savrActionTypes.SET_SAVR_PICKUP_LOCATION_CANDIDATES,
            payload: {
                locationKey: 'pickupLocation',
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchSAVRPickupLocationGeolocation;
